import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SCOPE_FEATURE_KEY, ScopeState, scopeAdapter } from './scope.reducer';
import { CallState, getError, LoadingState } from '@lyceo/shared/util-loading';
import { getPractiseTypesFromScopes } from './scope.functions';

export const selectScopeState =
  createFeatureSelector<ScopeState>(SCOPE_FEATURE_KEY);

const { selectAll, selectEntities } = scopeAdapter.getSelectors();

export const selectAllScopes = createSelector(
  selectScopeState,
  (state: ScopeState) => selectAll(state),
);

export const selectScopeEntities = createSelector(
  selectScopeState,
  selectEntities,
);

export const selectAvailableTypes = createSelector(selectAllScopes, (scopes) =>
  getPractiseTypesFromScopes(scopes),
);

export const selectPersonScopesCallState = createSelector(
  selectScopeState,
  (state: ScopeState) => state.personScopesCallState,
);

export const selectPersonScopesLoading = createSelector(
  selectPersonScopesCallState,
  (callState: CallState) =>
    callState === LoadingState.INIT || callState === LoadingState.LOADING,
);

export const selectPersonScopesLoaded = createSelector(
  selectPersonScopesCallState,
  (callState: CallState) => callState === LoadingState.LOADED,
);

export const selectPersonScopesError = createSelector(
  selectPersonScopesCallState,
  (callState: CallState) => getError(callState),
);

export const selectBookSelectModalScopeId = createSelector(
  selectScopeState,
  (state) => state.bookSelectModalScopeId,
);

export const selectBookSelectModalScope = createSelector(
  selectScopeEntities,
  selectBookSelectModalScopeId,
  (scopes, scopeId) => (scopeId ? scopes[scopeId] : undefined),
);
